<template>
  <div
    v-if="pageIsLoading"
    class="default-layout"
    :class="{
      'color-theme-dark': color_theme,
      mobile: isMobile,
      'grid-container': isDesktop,
      'side-menu-closed': !side_menu_mode
    }"
  >
    <side-menu class="side-menu" v-if="isDesktop" />
    <header-component class="top-menu" v-if="isDesktop" />
    <mobile-header-menu v-if="isMobile" />

    <div
      class="content-wrapper"
      :class="{
        'page-content': pageContent,
        mobile: isMobile,
        'non-padding': !pageContent && isMobile
      }"
    >
      <div class="header" v-if="$route.name !== 'Desktop'">
        <b-button
          v-if="isMobile && showBackButton"
          class="back detailed"
          @click="$router.go(-1)"
          variant="link"
        >
          {{ $t('back') }}
        </b-button>
        <h5 class="page-name" v-if="isDesktop || (isMobile && showBackButton)" v-html="pageName" />
        <b-breadcrumb
          :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
          v-if="isDesktop"
          :items="breadcrumbs"
        />
      </div>

      <div class="main">
        <slot></slot>
      </div>
    </div>
  </div>
  <div class="loading-main-layout" :class="{ dark: color_theme }" v-else>
    <b-spinner label="Spinning"></b-spinner>
  </div>
</template>

<script>
  import SideMenu from '@/components/main/SideMenu'
  import HeaderComponent from '@/components/main/HeaderComponent'
  import MobileHeaderMenu from '@/components/main/MobileHeaderMenu'
  import { mapState, mapGetters } from 'vuex'
  import { setCurrentSiteAndTariffToVuex } from '@/utils'

  export default {
    name: 'MainLayout',
    components: {
      SideMenu,
      HeaderComponent,
      MobileHeaderMenu
    },
    computed: {
      ...mapState([
        'color_theme',
        'language',
        'is_mobile_or_tablet',
        'side_menu_mode',
        'user',
        'current_site_info'
      ]),
      ...mapGetters(['pageName', 'breadcrumbs', 'userDoesNotHaveSites']),
      pageIsLoading() {
        return !!this.$route.name
      },
      isMobile() {
        return this.is_mobile_or_tablet
      },
      isDesktop() {
        return !this.is_mobile_or_tablet
      },
      pageContent() {
        if (!this.$route.name) return false

        const routesNames = [
          'Desktop',
          'leads',
          'instruments',
          'reports',
          'analytics',
          'analytics_kpi',
          'library',
          'settings'
        ]

        if (routesNames.includes(this.$route.name)) {
          return false
        }

        if (this.$route.meta.menu.includes('settings')) {
          return false
        }

        return true
      },
      showBackButton() {
        if (!this.$route.name) return false

        const routesNames = [
          'Desktop',
          'leads',
          'instruments',
          'reports',
          'analytics',
          'library',
          'settings'
        ]

        if (
          routesNames.includes(this.$route.name) ||
          this.$route.matched.some((el) => el.name === 'settings' || el.name === 'analytics')
        ) {
          return false
        }

        return true
      }
    },
    methods: {
      userIdentifyUsedeskMessenger(user, site) {
        const userInfo = {
          name: user.username,
          email: user.email,
          signature: user.id
        }

        if (site) {
          userInfo.additional_fields = [
            {
              id: 5300,
              value: site.domain
            },
            {
              id: 5301,
              value: site.id
            }
          ]
        }

        window.usedeskMessenger.userIdentify(userInfo)
      }
    },
    // watch: {
    //   current_site_info() {
    //     if (this.user && this.current_site_info) {
    //       this.userIdentifyUsedeskMessenger(this.user, this.current_site_info)
    //       window.usedeskMessenger && window.usedeskMessenger.toggle(true)
    //     }
    //   }
    // },
    mounted() {
      // const usedeskScript = document.createElement('script')
      // usedeskScript.setAttribute('async', '')
      // usedeskScript.src = 'https://lib.usedesk.ru/secure.usedesk.ru/widget_160220_26113.js'
      // document.head.append(usedeskScript)

      // usedeskScript.addEventListener('load', () => {
      //   window.usedeskMessenger.toggle(false)

      //   if (this.user && !this.user.sites.length) {
      //     this.userIdentifyUsedeskMessenger(this.user)
      //     window.usedeskMessenger.toggle(true)
      //   } else if (this.user && this.user.sites.length && this.current_site_info) {
      //     this.userIdentifyUsedeskMessenger(this.user, this.current_site_info)
      //     window.usedeskMessenger.toggle(true)
      //   }
      // })

      // if (this.user && this.user.sites.length && !this.current_site_info) {
      //   setCurrentSiteAndTariffToVuex.bind(this)()
      // }
    }
  }
</script>

<style lang="scss">
  .default-layout {
    width: 100%;
    min-height: 100%;
    position: relative;
    color: #5f6467;

    &.grid-container {
      min-width: 1520px;
      display: grid;
      grid-template-columns: auto calc(100% - 160px);
      grid-template-rows: 60px 1.3fr;
      gap: 0px 0px;
      grid-template-areas:
        'side-menu top-menu'
        'side-menu content-wrapper';

      &.side-menu-closed {
        grid-template-columns: auto calc(100% - 80px);
      }

      .side-menu {
        grid-area: side-menu;
      }

      .top-menu {
        grid-area: top-menu;
      }

      .content-wrapper {
        grid-area: content-wrapper;
        min-width: 1360px;
      }
    }

    &.mobile {
      display: flex;
      flex-direction: column;
      padding: 0 15px;
      min-height: 100vh;

      .content-wrapper {
        padding: 15px;
        border-radius: 3px;
        flex: 1 0 auto;
        display: flex;
        flex-direction: column;

        &::-webkit-scrollbar {
          width: 0;
        }

        &.page-content {
          background: #fafafa;
          border: 1px solid #cfd0d1;
          margin-bottom: 20px;

          .main {
            flex: 1 0 auto;
            display: flex;
            flex-direction: column;
          }
        }

        &.non-padding {
          padding: 0;
        }

        .page-name {
          font-size: 18px;
        }
      }
    }

    .content-wrapper {
      padding: 37px 19px 0 19px;
      width: 100%;
      height: 100%;

      .header {
        width: 100%;
        height: auto;

        .back {
          position: relative;
          top: -15px;
          left: -15px;
          background: #ff4402;
          color: #ffffff;
          width: 120px;
          height: 42px;
          font-size: 18px;
          margin-bottom: 20px;
        }
      }

      .main {
        width: 100%;
        height: auto;
      }
    }

    &.color-theme-dark {
      color: #cfd0d1;
      background: #3f4448;

      &.mobile {
        .content-wrapper {
          background: #2c3236;
          border-color: #5f6467;

          &.non-padding {
            padding: 0;
            background: #3f4448;
          }
        }
      }
    }
  }

  .loading-main-layout {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    z-index: 1999;

    &.dark {
      background: #2c3236;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/MainLayout.vue